export default __webpack_public_path__ + "static/media/harley-quinn.f98485e2.png";